import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PageNotFound from '../PageNotFound';

class Interview extends Component {
  getContent = (id) => {
    switch (id) {
      default: return <PageNotFound />;
    }
  }
  render() {
    const { match: { params: { id } } } = this.props;

    return (
      <Container>
        {this.getContent(id)}
      </Container>
    );
  }
}

export default Interview;
